import React, {Component} from 'react';
import {Button, Modal} from 'react-bootstrap';
import axios from 'axios';
import PleaseWait from '../PleaseWait';
import TableRow from './TableRow';

export default class BidReviewsDetailsModal extends Component {
    constructor(props) {
        super(props);

        this.state = {
            loading: false,
            data: [],
        };

        this.fetchData = this.fetchData.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.props.show !== prevProps.show && this.props.show) {
            this.fetchData(this.props.competitionId, this.props.bidId);
        }
    }

    fetchData(competitionId, bidId) {
        const url = `/competitions/bid-reviews/${competitionId}/${bidId}`;

        this.setState({loading: true}, () => {
            axios
                .get(url)
                .then((response) => {
                    this.setState({
                        loading: false,
                        data: response.data,
                    });
                });
        });
    }

    render() {
        return (
            <Modal show={this.props.show} onHide={this.props.onClose} bsSize="lg">
                <Modal.Header closeButton>
                    <Modal.Title>{window.__js_bid_reviews.reviewers_opinions}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <PleaseWait show={this.state.loading}/>

                    <div className="table-responsive">
                        <table className="table table-bordered table-striped table-hover">
                            <thead>
                            <tr>
                                <th className="bg-warning text-primary"></th>
                                <th colSpan={3} className="text-center">{window.__js_bid_reviews.documents_stage}</th>
                                <th colSpan={3} className="text-center bg-primary">{window.__js_bid_reviews.technical_bid_stage}</th>
                                <th colSpan={3} className="text-center">{window.__js_bid_reviews.financial_bid_stage}</th>
                            </tr>
                            <tr>
                                <th rowSpan={2} className="bg-warning text-primary">{window.__js_bid_reviews.reviewer}</th>
                                <th>{window.__js_general.status}</th>
                                <th>{window.__js_bid_reviews.rejection_reason}</th>
                                <th>{window.__js_bid_reviews.review_date}</th>
                                <th className="bg-primary">{window.__js_general.status}</th>
                                <th className="bg-primary">{window.__js_bid_reviews.rejection_reason}</th>
                                <th className="bg-primary">{window.__js_bid_reviews.review_date}</th>
                                <th>{window.__js_general.status}</th>
                                <th>{window.__js_bid_reviews.rejection_reason}</th>
                                <th>{window.__js_bid_reviews.review_date}</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                this.state.data.length === 0
                                    ? <tr>
                                        <td colSpan={20}>
                                            <em>{window.__js_bid_reviews.no_reviewers_set}</em>
                                        </td>
                                    </tr>
                                    : null
                            }
                            {this.state.data.map((item) => <TableRow key={item.assessor.id} data={item}/>)}
                            </tbody>
                        </table>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={this.props.onClose}>{window.__js_general.close}</Button>
                </Modal.Footer>
            </Modal>
        );
    }
}